import { createContext, useContext, useState, useEffect } from 'react';
import { getToken, removeToken, setToken ,setSessionTime} from '../utils/helper';
import { useNavigate, useLocation } from 'react-router-dom';
import { useFrappeGetCall } from 'frappe-react-sdk';
import { getTier } from '../client/api';

const userContext = createContext(null);

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    const { mutate } = useFrappeGetCall('headless_e_commerce.api.get_profile', {}, 'user-profile', {
        isOnline: () => getToken(),
        onSuccess: (data) => {
            setUser(prevUser => ({ ...prevUser, ...data.message }))
            getTier({ customer: data.message.name })
                .then((res) => setUser(prevUser => ({ ...prevUser, tier: res })))
        },
        onError: (error) => {
            // Invalid/expired token returns 401 or 403 — clear it and redirect to login
            if (error?.httpStatus === 401 || error?.httpStatus === 403 ||
                error?.message?.includes('403') || error?.message?.includes('401')) {
                setUser(null);
                removeToken();
                navigate("/login");
            }
        },
        onErrorRetry: (error) => {
            // Don't retry auth failures — they won't self-resolve
            if (error?.httpStatus === 401 || error?.httpStatus === 403 ||
                error?.message?.includes('403') || error?.message?.includes('401')) {
                return;
            }
        }
    })

    useEffect(() => {
        mutate();
    }, [mutate, location]);


    const login = async (usr, pwd) => {
        try {
            return fetch("https://hondanont.zaviago.com/api/method/frappeauth_app.authentication.login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    usr: usr,
                    pwd: pwd,
                }),
            }).then((response) => response.json()).then((data) => {
                if (data.message.token) {
                    setToken(data.message.token);
                    setSessionTime(Date.now());
                    mutate()
                }
                return data;
            })

        } catch (error) {
            return error;
        }
    };

    const logout = async () => {
        setUser(null);
        removeToken();
        navigate("/login");
    };

    return <userContext.Provider value={{
        user,
        login,
        logout,
        refetch: mutate
    }}>
        {children}
    </userContext.Provider>
}

export const useUser = () => useContext(userContext);